export const DATA_LOADER_LOADING_STATES = {
    GET_GLOBAL_FORMS_LIST_LOADING: "GET_GLOBAL_FORMS_LIST_LOADING",
    GET_GLOBAL_FORMS_LIST_READY: "GET_GLOBAL_FORMS_LIST_READY",
    GET_GLOBAL_FORMS_94X_LIST_LOADING: "GET_GLOBAL_FORMS_94X_LIST_LOADING",
    GET_GLOBAL_FORMS_94X_LIST_READY: "GET_GLOBAL_FORMS_94X_LIST_READY",
    GET_SCHEDULED_DATE_DEADLINES_LOADING: "GET_SCHEDULED_DATE_DEADLINES_LOADING",
    GET_SCHEDULED_DATE_DEADLINES_READY: "GET_SCHEDULED_DATE_DEADLINES_READY",
    GET_CONFIG_SETTINGS_LOADING: "GET_CONFIG_SETTINGS_LOADING",
    GET_CONFIG_SETTINGS_READY: "GET_CONFIG_SETTINGS_READY"
}